import { logError } from 'src/utils/logger';

// TODO:replace this with api-gateway
async function getSharedMembersFromApi (companyId, projectId) {
  const authentication = getCredentialToken();
  const myHeaders = new Headers();
  myHeaders.append('Authorization', authentication);
  const requestOptions = {
    method: 'GET',
    headers: myHeaders
  };

  const getMembersUrl = `${CONFIG.desygner_api}brand/companies/${companyId}/designs/${projectId}/permissions`;
  const response = await fetch(getMembersUrl, requestOptions);

  return await response.json();
}

// TODO:replace this with api-gateway
async function addUsersApi (companyId, projectId, userIds) {
  const authentication = getCredentialToken();
  const myHeaders = new Headers();
  myHeaders.append('Authorization', authentication);
  myHeaders.append('Content-Type', 'application/json');

  const addUserDataRequest = userIds.map((id, index) => {
    return {
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'Fetch',
        Authorization: authentication
      },
      id: index,
      method: 'post',
      body: JSON.stringify({ user: id, type: 'shared' }),
      url: `${CONFIG.desygner_api}brand/companies/${companyId}/designs/${projectId}/permissions`
    };
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(addUserDataRequest)
  };

  const batchApi = `${CONFIG.desygner_api}business/batch`;
  const response = await fetch(batchApi, requestOptions);

  return await response.json();
}

// TODO:replace this with api-gateway
async function removeUsersApi (companyId, projectId, users) {
  const authentication = getCredentialToken();
  const myHeaders = new Headers();
  myHeaders.append('Authorization', authentication);
  myHeaders.append('Content-Type', 'application/json');

  const addUserDataRequest = users.map((user, index) => {
    return {
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'Fetch',
        Authorization: authentication
      },
      id: index,
      method: 'delete',
      body: JSON.stringify({ user: user.id, type: user.permissionType }),
      url: `${CONFIG.desygner_api}brand/companies/${companyId}/designs/${projectId}/permissions/${user.permissionId}`
    };
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(addUserDataRequest)
  };

  const batchApi = `${CONFIG.desygner_api}business/batch`;
  const response = await fetch(batchApi, requestOptions);

  return await response.json();
}

// TODO:replace this with api-gateway
async function searchMemberFromApi (
  keyword,
  companyId,
  status,
  limit,
  offset
) {
  const authentication = getCredentialToken();
  const myHeaders = new Headers();
  myHeaders.append('Authorization', authentication);
  const requestOptions = {
    method: 'GET',
    headers: myHeaders
  };

  const getCompanyMembersUrl = `${CONFIG.desygner_api}brand/companies/${companyId}/memberships?q=${keyword}&status=${status}&limit=${limit}&first=${offset}`;
  const response = await fetch(getCompanyMembersUrl, requestOptions);

  return await response.json();
}

// TODO:replace this with api-gateway
async function getUserInfoApi (companyId, userIds) {
  const authentication = getCredentialToken();
  const myHeaders = new Headers();
  myHeaders.append('Authorization', authentication);
  myHeaders.append('Content-Type', 'application/json');

  const memberInfoDataRequest = userIds.map((id, index) => {
    return {
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'Fetch',
        Authorization: authentication
      },
      id: index,
      method: 'get',
      url: `${CONFIG.desygner_api}brand/companies/${companyId}/memberships?u=${id}`
    };
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(memberInfoDataRequest)
  };

  const batchApi = `${CONFIG.desygner_api}business/batch`;
  const response = await fetch(batchApi, requestOptions);
  const batchData = await response.json();

  return batchData
    .filter((data) => data.status === 200)
    .map((data) => JSON.parse(data.body)[0]?.user)
    .filter((userProfile) => !!userProfile)
    .map((userProfile) => {
      const profilePictureDetail =
        userProfile.details &&
        userProfile.details.find((detail) => detail.type === 'profile_picture')
          ?.content;
      userProfile.profile_picture =
        profilePictureDetail || userProfile.profile_picture;

      return userProfile;
    });
}

export async function getSharedMembers () {
  try {
    const projectData = await INKIVE.PageFactory.getProjectData();
    const companyId = INKIVE.CompanyFactory?.companyId || projectData.company?.id;
    const permissionData = await getSharedMembersFromApi(
      companyId,
      projectData.id
    );

    const userIds = permissionData.map((data) => data.user);
    const userInfo = await getUserInfoApi(companyId, userIds);

    return userInfo.map(function (user) {
      const permission = permissionData.find(member => member.user === user.id);
      user.permissionId = permission.id;
      user.permissionType = permission.type;

      return user;
    });
  } catch (error) {
    logError('getSharedMembers', error);
  }

  return [];
}

export async function searchMembers (keyword, {
  offset = 0,
  limit = 30
}) {
  const status = 2;

  try {
    return await searchMemberFromApi(
      keyword,
      INKIVE.CompanyFactory.companyId,
      status,
      limit,
      offset
    );
  } catch (error) {
    logError('searchMembers', error);
  }
}

export async function addUsers (users) {
  if (users.length === 0) {
    return;
  }

  const projectData = await INKIVE.PageFactory.getProjectData();

  try {
    return await addUsersApi(
      INKIVE.CompanyFactory.companyId,
      projectData.id,
      users.map((user) => user.id)
    );
  } catch (error) {
    logError('addUsers', error);
  }
}

export async function removeUsers (users) {
  if (users.length === 0) {
    return;
  }

  try {
    const projectData = await INKIVE.PageFactory.getProjectData();

    return await removeUsersApi(
      INKIVE.CompanyFactory.companyId,
      projectData.id,
      users
    );
  } catch (error) {
    logError('removeUsers', error);
  }
}

export function setTeamSharedProject (isTeamShared) {
  INKIVE.CompanyFactory.setProjectData({ is_team_shared: isTeamShared });
}

export function getUserName (member) {
  const userFirstNameFromDetails = member.details.find((detail) => detail.type === 'first_name')?.content;
  const userLastNameFromDetails = member.details.find((detail) => detail.type === 'last_name')?.content;

  const nameFromDetails = [userFirstNameFromDetails, userLastNameFromDetails].filter(Boolean).join(' ');
  if (nameFromDetails) return nameFromDetails;

  const userFirstNameFromUser = member.user.details.find((detail) => detail.type === 'first_name')?.content;
  const userLastNameFromUser = member.user.details.find((detail) => detail.type === 'last_name')?.content;

  const nameFromUser = [userFirstNameFromUser, userLastNameFromUser].filter(Boolean).join(' ');

  return nameFromUser || member.user.nickname;
}

export function normalizeSearchMember (member) {
  return {
    id: member.user.id,
    name: getUserName(member),
    sourceUrl:
      member.user.details.find((detail) => detail.type === 'profile_picture')
        ?.content || member.user.profile_picture
  };
}

export function getCredentialToken () {
  const credentials = CONFIG.credentials;
  const authenticationToken =
    'Basic ' + btoa(`${credentials.token}:${credentials.hash}`);

  return authenticationToken;
}
